module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"home":"门户","email":"邮箱","setHome":"设为首页"},"ru":{"email":"Электронная почта","setHome":"Установить в качестве главной страницы"}}')
  delete Component.options._Ctor
}
